import React, { useState } from 'react'
import Layout from '../../components/Layout/Layout'
import { Link } from 'react-router-dom'
import { Map, GoogleApiWrapper } from 'google-maps-react';
import styles from './PickupLocation.module.css'

const mapStyles = {
    width: '100%',
    height: '100%'
};

const PickupLocation = (props) => {
    const [isOpen, setIsOpen] = useState(false)

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            setIsOpen(true)
        }
    }
    return (
        <Layout title="Pickup Location" route={"/"} >
            <div className={styles.mapsContainer}>
                <Map
                    google={props.google}
                    zoom={14}
                    style={mapStyles}
                    initialCenter={
                        {
                            lat: -1.2884,
                            lng: 36.8233
                        }
                    }
                />
            </div>
            <div className={styles.inputContainer}>
                <div className={styles.input}>
                    <i className={styles.icon + " fas fa-map-marker-alt"}></i>
                    <input type="text" name="location" placeholder="Enter Pickup Location" onKeyPress={handleKeyPress} />
                </div>
            </div>
            {
                isOpen
                    ?
                    <div className={styles.detailContainer}>
                        <div className={styles.input_2}>
                            <i className={styles.icon + " fas fa-map-marker-alt"}></i>
                            <input type="text" name="location" placeholder="Enter Pickup Location" />
                        </div>
                        <div className={styles.input_2}>
                            <i className={styles.icon + " fas fa-map-marker-alt"}></i>
                            <input type="text" name="place" placeholder="Enter Drop Location" />
                        </div>
                        <div className={styles.input_2}>
                            <i className={styles.icon + " fas fa-user"}></i>
                            <input type="text" name="location" placeholder="Name of person" />
                        </div>
                        <div className={styles.input_2}>
                            <i className={styles.icon + " fas fa-phone"}></i>
                            <input type="text" name="location" placeholder="Contact Number" />
                        </div>
                        <Link to="/drop-location">
                            <button>Continue <i className={styles.icon + " fas fa-long-arrow-alt-down"}></i></button>
                        </Link>
                    </div>
                    :
                    null
            }
        </Layout>
    )
}

export default GoogleApiWrapper({
    apiKey: "AIzaSyCbGCVUGEoqvURirLROMcMTVXHS0XWlJVk"
})(PickupLocation);
